import { cx } from '@/utils';

export default function Container({ children, className = '', fullWidth = false }) {
  return (
    <div
      className={cx(
        fullWidth
          ? 'container mx-auto px-5'
          : 'container mx-auto max-w-screen-lg px-5 py-5 lg:py-8 xl:px-5',
        className,
      )}
    >
      {children}
    </div>
  );
}
